import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Text from 'components/common/Text/Text'
import Theme from 'src/components/common/Theme/Theme'
import MakeAndModelEditor from './components/MakeAndModelEditor'
import { MAKE_MODEL_INSTRUCTIONS, DISABLED_MAKE_MODEL_INSTRUCTIONS } from '../constants'

const MakeAndModel = ({
  userVehicleDetails: {
    editVehicle
  } = {},
  userVehicleDetails,
  ...props
}) =>
  <Wrapper>
    <Instructions data-at-instructions>
      { editVehicle ? MAKE_MODEL_INSTRUCTIONS : DISABLED_MAKE_MODEL_INSTRUCTIONS }
    </Instructions>
    <FormWrapper>
      <MakeAndModelEditor { ...props } userVehicleDetails={ userVehicleDetails } />
    </FormWrapper>
  </Wrapper>

export default MakeAndModel

MakeAndModel.propTypes = {
  userVehicleDetails: PropTypes.shape({
    editVehicle: PropTypes.bool
  })
}

const Instructions = styled(Text)`
  color: ${Theme.colors.dark_grey};
  line-height: 22px;
  margin-bottom: 20px;
  display: block;
`

const Wrapper = styled.div`
  padding-top: 15px;
`

const FormWrapper = styled.div`
  margin: 0 auto 45px;
`
